var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import widgetsDictionary from "../widgetsDictionary";
import { useChatIAMutation, useGetConnectorsQuery } from "@/store/api";
import { useParams } from "react-router-dom";
import { Option, Select, Textarea } from "@mui/joy";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faSend, faSparkles, faTriangleExclamation, } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
export default function WidgetChatIA(_a) {
    var _this = this;
    var widget = _a.widget;
    var t = useTranslation(["common"]).t;
    var payload = widget.payload && widget.payload;
    var _b = useChatIAMutation(), chatIA = _b[0], isLoading = _b[1].isLoading;
    var _c = useState([]), messages = _c[0], setMessages = _c[1];
    var _d = useState(""), input = _d[0], setInput = _d[1];
    var module = useParams().module;
    var systemPrompt = "You are a SuiteCRM assistant for ".concat(module || "Accounts", " module.");
    useEffect(function () {
        if (messages.length === 0) {
            setMessages([
                { role: "ai", text: "".concat(t("app.LBL_INIT_MESSAGE", { ns: "common" })) },
            ]);
        }
    }, []);
    var handleSend = function () { return __awaiter(_this, void 0, void 0, function () {
        var now, result, aiReply_1, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!input.trim())
                        return [2 /*return*/];
                    now = new Date();
                    setMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ role: "user", text: input, time: now }], false); });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, chatIA({
                            body: { message: input, systemPrompt: systemPrompt, module: module, id: payload.idLLM },
                        }).unwrap()];
                case 2:
                    result = _b.sent();
                    aiReply_1 = ((_a = result.data) === null || _a === void 0 ? void 0 : _a.reply) || result.reply || "";
                    setMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                        { role: "ai", text: aiReply_1, time: new Date() },
                    ], false); });
                    setInput("");
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _b.sent();
                    setMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                        {
                            role: "ai",
                            text: " Error talking to AI. Please try again.",
                            time: new Date(),
                        },
                    ], false); });
                    return [3 /*break*/, 5];
                case 4:
                    setInput("");
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var formatMessage = function (text) {
        return text
            .replace(/\*\*(.*?)\*\*/g, '<span class="font-bold">$1</span>')
            .replace(/\*(.*?)\*/g, '<span class="italic">$1</span>');
    };
    var messagesEndRef = useRef(null);
    var scrollToBottom = function () {
        var _a;
        (_a = messagesEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
    };
    useEffect(function () {
        scrollToBottom();
    }, [messages]);
    return (_jsxs("div", __assign({ className: "flex flex-col !h-full  shadow-lg overflow-hidden bg-[var(--colors-body-bg)] " }, { children: [_jsx("div", __assign({ className: "flex items-center shadow-sm justify-between px-4 py-3 bg-gradient-to-r bg-[var(--colors-widget)] text-[var(--colors-label)] shrink-0" }, { children: _jsxs("div", __assign({ className: "flex items-center gap-2 font-semibold" }, { children: [_jsx("span", __assign({ className: "bg-[var(--colors-bg-default)] text-blue-600 rounded-full w-8 h-8 flex items-center justify-center" }, { children: _jsx(FontAwesomeIcon, { icon: faSparkles }) })), t("app.LBL_CHAT_AI", { ns: "common" })] })) })), _jsxs("div", __assign({ className: "flex-1  overflow-y-auto px-3 py-2 space-y-2 " }, { children: [messages.map(function (msg, i) {
                        var _a;
                        return (_jsxs("div", __assign({ className: "max-w-[75%]  px-3 py-2 mb-2 text-sm rounded-2xl shadow-md ".concat(msg.role === "user"
                                ? "ml-auto bg-[var(--colors-widget)] text-[var(--colors-label)] rounded-br-md"
                                : "mr-auto bg-[var(--colors-body-bg-sec)]  text-[var(--colors-label)] rounded-bl-md") }, { children: [msg.text === "" ? (_jsxs("span", __assign({ className: " text-[var(--colors-danger-outlinedColor)]" }, { children: [_jsx(FontAwesomeIcon, { icon: faTriangleExclamation }), " ", t("app.LBL_CHAT_ERROR", { ns: "common" })] }))) : (msg.text
                                    .split(/(\*\*.*?\*\*)/g)
                                    .map(function (part, idx) {
                                    if (part.startsWith("**") && part.endsWith("**")) {
                                        return (_jsx("span", __assign({ className: "font-bold" }, { children: part.slice(2, -2) }), idx));
                                    }
                                    return part.split("\n").map(function (line, lineIdx) {
                                        if (line.startsWith("- ")) {
                                            return (_jsx("div", __assign({ className: "ml-4 list-disc" }, { children: _jsxs("li", { children: [" ", line.slice(2)] }) }), "".concat(idx, "-").concat(lineIdx)));
                                        }
                                        return (_jsxs("span", { children: [line, _jsx("br", {})] }, "".concat(idx, "-").concat(lineIdx)));
                                    });
                                })), _jsx("div", __assign({ className: "text-[10px] mt-1 text-right ".concat(msg.role === "user"
                                        ? "text-[var(--colors-label)] "
                                        : "text-gray-400") }, { children: (_a = msg.time) === null || _a === void 0 ? void 0 : _a.toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    }) }))] }), i));
                    }), isLoading && (_jsx("div", __assign({ className: " items-center justify-center flex mr-auto bg-[var(--colors-body-bg-sec)] px-2 rounded-2xl text-sm text-gray-500 shadow-md w-fit animate-pulse" }, { children: _jsx("span", __assign({ className: "justify-center text-[var(--colors-label)] text-lg" }, { children: _jsx(FontAwesomeIcon, { icon: faEllipsis }) })) }))), _jsx("div", { ref: messagesEndRef })] })), _jsx("div", __assign({ className: "relative flex items-center p-3 border-[var(--colors-widget-border)] border-t  shrink-0" }, { children: _jsxs("div", __assign({ className: "relative w-full" }, { children: [_jsx(Textarea, { maxRows: 4, value: input, onChange: function (e) { return setInput(e.target.value); }, onKeyDown: function (e) {
                                if (e.key === "Enter" && !e.shiftKey && !isLoading) {
                                    e.preventDefault();
                                    handleSend();
                                    setInput("");
                                }
                            }, placeholder: "".concat(t("app.LBL_ASK_ANYTHING", { ns: "common" })), sx: {
                                width: "100%",
                                borderRadius: "20px",
                                border: "1px solid #CBD5E1",
                                paddingRight: "2.5rem",
                                resize: "none",
                                fontSize: "14px",
                                "&:focus": {
                                    boxShadow: "0 0 0 2px rgba(59,130,246,0.5)",
                                    borderColor: "#3B82F6",
                                },
                            } }), _jsx("button", __assign({ onClick: handleSend, disabled: isLoading || !input.trim(), className: "absolute right-1 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full text-[var(--colors-label)]  flex items-center justify-center hover:bg-blue-700 disabled:opacity-50 transition" }, { children: _jsx(FontAwesomeIcon, { icon: faSend, size: "xs" }) }))] })) }))] })));
}
function ChatIASettings(_a) {
    var _b, _c, _d, _e, _f;
    var widget = _a.widget, onChange = _a.onChange;
    var _g = useState((_c = (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.idLLM) !== null && _c !== void 0 ? _c : null), selectedConnectorId = _g[0], setSelectedConnectorId = _g[1];
    // Sync when widget payload changes (important!)
    useEffect(function () {
        var _a;
        if ((_a = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _a === void 0 ? void 0 : _a.idLLM) {
            setSelectedConnectorId(widget.payload.idLLM);
        }
    }, [(_d = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _d === void 0 ? void 0 : _d.idLLM]);
    var _h = useGetConnectorsQuery(null), backendConnectors = _h.data, isLoadConnector = _h.isLoading;
    useEffect(function () {
        var _a;
        var list = (_a = backendConnectors === null || backendConnectors === void 0 ? void 0 : backendConnectors.data) === null || _a === void 0 ? void 0 : _a.connectors;
        if (list && list.length > 0 && !selectedConnectorId) {
            setSelectedConnectorId(list[0].id);
        }
    }, [backendConnectors]);
    return (_jsxs("div", __assign({ className: "p-2 text-sm" }, { children: [_jsx("p", { children: "Select your Model LLM" }), _jsx(Select, __assign({ size: "sm", value: widget === null || widget === void 0 ? void 0 : widget.payload.idLLM, onChange: function (_, value) {
                    setSelectedConnectorId(value);
                    onChange && onChange(widget, __assign(__assign({}, widget === null || widget === void 0 ? void 0 : widget.payload), { idLLM: value }));
                }, placeholder: "Select LLM", disabled: isLoadConnector, sx: {
                    minWidth: 180,
                    backgroundColor: "white",
                    color: "#111827",
                } }, { children: (_f = (_e = backendConnectors === null || backendConnectors === void 0 ? void 0 : backendConnectors.data) === null || _e === void 0 ? void 0 : _e.connectors) === null || _f === void 0 ? void 0 : _f.map(function (c) { return (_jsx(Option, __assign({ value: c.id }, { children: c.name }), c.id)); }) }))] })));
}
widgetsDictionary.register("widget/chatIA", {
    name: "Widget ChatIA",
    display: WidgetChatIA,
    settings: ChatIASettings,
});
